module.exports = __webpack_public_path__ + "static/NodeJS-Iphone-Still-3011ad2c2dbe58da947ba07e829e6805.jpg";